import { Skeleton } from "@mui/material";
import React from "react";

interface SidebarSkeletonProps {}

const SidebarSkeleton = (props: SidebarSkeletonProps) => {
  const renderSidebarItemSkeletons = () => {
    const skeletons = [];

    for (let i = 0; i < 20; i++) {
      skeletons.push(
        <Skeleton
          variant="rounded"
          width={200}
          height={48}
          className="dui-sidebar-item-skeleton"
          key={i}
        />
      );
    }
    return skeletons;
  };
  return (
    <div className="dui-sidebar-skeleton">
      <div>{renderSidebarItemSkeletons()}</div>
    </div>
  );
};

export default SidebarSkeleton;
